// The key a CMS query is known by in the SSR copy (./ssr-cms.js), in a
// language. Kept apart from ssr-cms.js so the browser bundle of CMSData does
// not take in the server fetching.
export const ssrCMSKey = ({ contentType, match, sort, itemsPerPage = 1000, page = 1, expand = false }, language) =>
  `${contentType}:${JSON.stringify(match ?? null)}:${sort ?? ""}:${itemsPerPage}:${page}:${language}:${expand}`

export default ssrCMSKey
